export default "__VITE_ASSET__1f7b8a03__"